<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'OtherServicesHome'
  }
</script>

<style lang="scss">

</style>
